(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/divider/assets/javascripts/divider-v2.js') >= 0) return;  svs.modules.push('/modules/divider/assets/javascripts/divider-v2.js');
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

svs = svs || {};
svs.content = svs.content || {};
svs.content.divider = svs.content.divider || {};
var initZDegree = function initZDegree() {
  return "".concat(Number(gsap.utils.random(1, 10)), "deg");
};
svs.content.divider.V2 = function () {
  var sport, tur, sportBrands, turBrands, sportTextLines, turTextLines, turArrow, sportArrow;
  var init = function init() {
    sport = document.querySelector('.divider-v2-sport');
    tur = document.querySelector('.divider-v2-tur');
    sportBrands = sport.querySelectorAll('.divider-v2-brand');
    turBrands = tur.querySelectorAll('.divider-v2-brand');
    sportTextLines = _toConsumableArray(sport.querySelectorAll('.divider-v2-text-animate'));
    turTextLines = _toConsumableArray(tur.querySelectorAll('.divider-v2-text-animate'));
    turArrow = tur.querySelector('.divider-v2-icon-arrow');
    sportArrow = sport.querySelector('.divider-v2-icon-arrow');

    gsap.set([sport, tur], {
      scale: 0.9,
      opacity: 0
    });
    gsap.set([turBrands[0], sportBrands[0]], {
      y: 20,
      opacity: 0,
      rotationZ: initZDegree
    });
    gsap.set([turBrands[1], sportBrands[1]], {
      y: 20,
      opacity: 0,
      rotationZ: initZDegree
    });
    gsap.set([turBrands[2], sportBrands[2]], {
      y: 20,
      opacity: 0,
      rotationZ: initZDegree
    });
    gsap.set([turBrands[3], sportBrands[3]], {
      y: 20,
      opacity: 0,
      rotationZ: initZDegree
    });
    gsap.set([turBrands[4], sportBrands[4]], {
      y: 20,
      opacity: 0,
      rotationZ: initZDegree
    });
    gsap.set([sportTextLines, turTextLines], {
      y: 20,
      opacity: 0
    });
    gsap.set([turArrow, sportArrow], {
      x: -20,
      opacity: 0
    });

    var params = new window.URLSearchParams(window.location.search);
    var forceAnimation = Boolean(params.get('animate'));
    if (!forceAnimation) {
      svs.components.Storage.browser.get('seen-animation', 'Divider', function (result) {
        initAnimations(result);
      });
    } else {
      initAnimations();
    }
  };
  var initAnimations = function initAnimations(seen) {
    svs.components.Storage.browser.set('seen-animation', 'Divider', {
      msg: 'Yes'
    }, 60 * 12);
    animateIn(seen);
    if (svs.core.detect.formfactor.desktop()) {
      addEventListeners();
    }
  };
  var addEventListeners = function addEventListeners() {
    sport.addEventListener('mouseenter', function () {
      hoverBrands(sportBrands);
      hoverArrow(sportArrow);
    });
    sport.addEventListener('mouseleave', function () {
      animateBrandsBack(sportBrands);
      animateArrowBack(sportArrow);
    });

    tur.addEventListener('mouseenter', function () {
      hoverBrands(turBrands);
      hoverArrow(turArrow);
    });
    tur.addEventListener('mouseleave', function () {
      animateBrandsBack(turBrands);
      animateArrowBack(turArrow);
    });
  };
  var animateIn = function animateIn(seen) {
    var tl = gsap.timeline();
    tl.to([sport, tur], {
      scale: 1,
      opacity: 1,
      duration: 0.3,
      stagger: 0.2
    });
    tl.to([sportBrands, turBrands, sportArrow, turArrow], {
      x: 0,
      y: 0,
      opacity: 1,
      duration: 0.4,
      stagger: 0.05
    }, '-=0.4');
    tl.to([sportTextLines, turTextLines], {
      y: 0,
      opacity: 1,
      duration: 0.4,
      stagger: 0.05
    }, '-=0.8');

    if (seen) {
      tl.progress(1, false);
    }
  };
  var animateBrandsBack = function animateBrandsBack(brands) {
    brands.forEach(function (brand) {
      gsap.to(brand, {
        x: 0,
        y: 0,
        duration: function duration() {
          return Number(gsap.utils.random(20, 40) / 10).toFixed(2);
        },
        rotationZ: 0,
        ease: 'back.out(0.5)',
        overwrite: true
      });
    });
  };
  var hoverBrands = function hoverBrands(brands) {
    brands.forEach(function (brand, i) {
      gsap.to(brand, {
        x: i < 3 ? -15 : 15,
        y: Number(gsap.utils.random(-5, 5)),
        duration: function duration() {
          return Number(gsap.utils.random(5, 30) / 10).toFixed(2);
        },
        ease: 'back.out',
        overwrite: true
      });
    });
  };
  var hoverArrow = function hoverArrow(arrow) {
    gsap.to(arrow, {
      duration: 0.6,
      repeat: -1,
      yoyo: true,
      ease: 'quad.in',
      x: 10,
      overwrite: true
    });
  };
  var animateArrowBack = function animateArrowBack(arrow) {
    gsap.to(arrow, {
      x: 0,
      overwrite: true
    });
  };
  return {
    init: init
  };
};

 })(window);